import { render, staticRenderFns } from "./AmcContract.vue?vue&type=template&id=295e6fa7&scoped=true&"
import script from "./AmcContract.vue?vue&type=script&lang=js&"
export * from "./AmcContract.vue?vue&type=script&lang=js&"
import style0 from "./AmcContract.vue?vue&type=style&index=0&id=295e6fa7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "295e6fa7",
  null
  
)

export default component.exports